// Public Profile Page
import React from 'react';
import { NextSeo } from 'next-seo';
import { NextPageWithLayout } from 'types/page';
import ProfileView from 'components/views/PublicProfile';

/**
 * Public Profile: Page description
 * @return {NextPageWithLayout}
 */
const PageTitle = 'Profile';
const Profile: NextPageWithLayout<{ id: string }> = ({ id }) => {
  // TODO: Pre-fetching or ISR for performance
  // - https://swr.vercel.app/docs/prefetching
  // ISR in profile/iframe
  return (
    <>
      <NextSeo title={PageTitle} />
      <ProfileView id={id} />
    </>
  );
};

Profile.getInitialProps = ({ query }) => ({
  // TODO:
  // - [] SSR/ISR
  // - [] Check for id

  id: (query.id as string[])[0],
});

export default Profile;
